import { Avatar, Box, type AvatarProps } from '@ff-it/ui';
import type { EmbeddedUser } from 'modules/core/types';
import { getUserTitle } from 'modules/core/helpers';
import { useId } from 'react';
import { Tooltip } from 'react-tooltip';

type UserAvatarProps = {
  user: Pick<EmbeddedUser, 'first_name' | 'last_name' | 'email'>;
  size?: AvatarProps['size'];
  color?: string;
  noTooltip?: boolean;
};

export function UserAvatar({
  user: { first_name, last_name, email },
  size,
  color,
  noTooltip = false,
}: UserAvatarProps) {
  let first: string;
  let last: string;
  if (first_name && last_name) {
    first = first_name.charAt(0);
    last = last_name.charAt(0);
  } else {
    const [user, domain] = email.split('@', 2);
    first = user.charAt(0);
    last = domain.charAt(0);
  }
  const repr = getUserTitle({ first_name, last_name, email });

  const id = useId();

  return (
    <Box display="inline" position="relative" data-tooltip-id={id}>
      <Avatar size={size} style={color ? { backgroundColor: color } : undefined}>
        {first}
        {last}
      </Avatar>
      {!noTooltip && <Tooltip id={id}>{repr}</Tooltip>}
    </Box>
  );
}
